import React, { Component } from 'react';
import PropTypes from 'prop-types';


const DEFAULT_COLOR = '#0072ff';

/** 
 * <p></p>
 */
class SelectIndicator extends Component {
    constructor(props) {
        super(props);
    }

    /**
     * Ok componentDidMount desc
     */
    componentDidMount() {

    }
    componentWillUnmount() {

    }

    handleMouseDown(e) {

    }
    handleMouseUp(e) {

    }


    handleMouseMove(e) {

    }




    render() {
        const color = this.props.color !== undefined ? this.props.color : DEFAULT_COLOR;
        const size = this.props.size !== undefined ? this.props.size : 1;
        
        return <div
            style={{
                position: 'absolute',
                borderRadius: '5px',
                border: size + 'px solid ' + color,
                left: -size*2,
                top: -size*2,
                width: 'calc(100% + '+(size*4)+'px)',
                height: 'calc(100% + '+(size*4)+'px)',
                pointerEvents: 'none',

                // boxShadow: '0px 0px 5px 2px ' + color
            }}
        ></div>;
         }
}

SelectIndicator.displayName = "SelectIndicatorComponent";

const connectedComponent = SelectIndicator;
// connect(
//     mapStateToProps,
//     {
//         ...actions
//     }
// )(Resize);
// connectedComponent.displayName = "Resize";

SelectIndicator.propTypes = {
};

export default connectedComponent;
export { SelectIndicator as SelectIndicatorComponent };